export function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="100%"
      height="100%"
      viewBox="0 0 44 44"
    >
      <path
        d="M30.00776195526123,6.600000386102295C30.00776195526123,7.047645286102295,29.82593295526123,7.476084486102295,29.50385395526123,7.7870103861022955L14.783245555261232,22.000001286102297L29.50253395526123,36.211671286102295L29.50385395526123,36.212991286102294C29.82593395526123,36.52396128610229,30.00776195526123,36.95230028610229,30.00776195526123,37.400001286102295C30.00776195526123,38.3112402861023,29.26900195526123,39.0500022861023,28.357761955261232,39.0500022861023C27.93019195526123,39.0500022861023,27.51934195526123,38.884010286102296,27.211672955261232,38.587009286102294L27.210352955261232,38.585799286102294L11.261683885261231,23.187007286102293C10.60611687526123,22.554069286102294,10.58779083526123,21.509507286102295,11.22075286526123,20.853908286102296C11.23416188526123,20.840048286102295,11.247801895261231,20.826408286102293,11.261683885261231,20.812988286102296L27.21068295526123,5.413911726102295C27.51934295526123,5.115987736102295,27.93019395526123,4.949997729062895,28.357761955261232,4.949997729062895C29.26900195526123,4.949997729062895,30.00776195526123,5.688724756102295,30.00776195526123,6.600000386102295Z"
        fill="currentColor"
        fillOpacity="1"
      />
    </svg>
  );
}

export function ArrowDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
    >
      <path
        d="M32.25005989074707,19.332423119409178C32.25005989074707,19.61729051940918,32.13431889074707,19.88993121940918,31.929359890747072,20.08779261940918L24.01173519074707,27.732423819409178L31.929359890747072,35.37702401940918C32.13431889074707,35.57490301940918,32.25005989074707,35.847544019409185,32.25005989074707,36.13242301940918C32.25005989074707,36.71232401940918,31.779959890747072,37.18242501940918,31.20005989074707,37.18242501940918C30.927961390747072,37.18242501940918,30.66647909074707,37.07682401940918,30.47076039074707,36.88782301940918L30.469800990747068,36.88692301940918L21.77073708074707,28.487823019409177C21.353557578747072,28.08498381940918,21.34189262074707,27.420301419409178,21.74469149074707,27.00312331940918C21.75322306074707,26.994242619409178,21.76190454074707,26.98560241940918,21.77073708074707,26.97702411940918L30.47028159074707,18.57752152940918C30.666481990747073,18.38805312940918,30.927961390747072,18.28242301940918,31.20006279074707,18.28242301940918C31.779962890747072,18.28242301940918,32.250062890747074,18.75252344940918,32.25005989074707,19.332423119409178Z"
        fill="currentColor"
        fillOpacity="1"
        transform="matrix(0,-1,-1,0,39.73248291015625,39.73248291015625)"
      />
    </svg>
  );
}
